/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4DiagMaxIcon16Solid = forwardRef('ArrowDim4DiagMaxIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9 2a1 1 0 0 1 1-1h3a2 2 0 0 1 2 2v3a1 1 0 1 1-2 0V4.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L11.586 3H10a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M3 4.414V6a1 1 0 0 1-2 0V3a2 2 0 0 1 2-2h3a1 1 0 0 1 0 2H4.414l2.293 2.293a1 1 0 0 1-1.414 1.414L3 4.414Z" }),
        React.createElement("path", { d: "m3 11.586 2.293-2.293a1 1 0 0 1 1.414 1.414L4.414 13H6a1 1 0 1 1 0 2H3a2 2 0 0 1-2-2v-3a1 1 0 0 1 2 0v1.586Z" }),
        React.createElement("path", { d: "M9.293 10.707 11.586 13H10a1 1 0 1 0 0 2h3a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v1.586l-2.293-2.293a1 1 0 0 0-1.414 1.414Z" })));
});
